import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { Link } from 'react-router-dom';
import { StorableIcon } from 'src/components';
import type { ReminderListRow } from 'src/components/reminders/ColumnDef';
import { openLinkFromAnchorClick } from 'src/helpers';
import { alineLinkButtonStylesWithUnderlineNotBold, createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  nameLink: {
    // The anchor is now the flex child, so it carries the sizing the text used to.
    flex: 1,
    minWidth: 0,
    textDecoration: 'none',
  },
  nameText: {
    ...createClampStyles(3),
    ...alineLinkButtonStylesWithUnderlineNotBold,
  },
  row: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    minWidth: 0,
    overflow: 'hidden',
    width: '100%',
  },
}));

export function ReminderDocumentCell({
  value,
}: GridCellParams<ReminderListRow, ReminderListRow['document']>) {
  const { classes } = useStyles();

  if (!value) return null;

  const documentHref = link.DocumentDetail({ documentId: value.id });
  const title = value.name || 'Untitled Document';

  return (
    <div className={classes.row}>
      <StorableIcon storable={value} />
      <Link
        className={classes.nameLink}
        to={documentHref}
        onClick={e => openLinkFromAnchorClick(e, documentHref, { title })}
      >
        <Typography className={classes.nameText} variant="subtitle2">
          {value.name || 'Untitled'}
        </Typography>
      </Link>
    </div>
  );
}
